import React, { Fragment } from "react";
import { Container, Row, Col } from 'reactstrap';

const ScoreCardItem = props => (
    <Container>
    </Container>
);

export default ScoreCardItem;
